import { render, staticRenderFns } from "./meal-image.vue?vue&type=template&id=f86bba42&"
import script from "./meal-image.vue?vue&type=script&lang=js&"
export * from "./meal-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports